import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=36c644f0&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=ts&"
export * from "./LineChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c644f0",
  null
  
)

export default component.exports